import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';
import type { BitcoinProvider } from 'sats-connect';

const MAGIC_EDEN_BITCOIN_PROVIDER_LOCATOR = 'magicEden.bitcoin';

export const getMagicEdenInjectedProvider = () => {
  return getInjectedProviderFromWindow<BitcoinProvider>(
    MAGIC_EDEN_BITCOIN_PROVIDER_LOCATOR
  );
};
